"use strict";

jQuery(function($) {
    // WOOCOMMERCE SHOPHOME CAT BUTTON TOGGLE
    function onMobileToggleClick(e) {
		e.preventDefault();
		var $body = $('body');
		var prefix = 'category';
		var bodyClass = [ prefix + '--overlay-open' ];
		var delayMs;
		if ($body.hasClass(bodyClass[0])) {
			delayMs = 300;
			bodyClass.unshift(prefix + '--open');
		} else {
			delayMs = 10;
			bodyClass.push(prefix + '--open');
		}
		$body.toggleClass(bodyClass.shift());
		setTimeout(() => {
			$body.toggleClass(bodyClass.shift());
		}, delayMs);
	}
	$('.category__mobile-toggle-button.js-mobile-toggle, .category__sidebar__close-button.js-mobile-toggle').on('click', onMobileToggleClick);


    // Toggle display of dropdown menu on mobile on the shop category page in the navbar
    $( '.shop-category__category-navbar__label' ).on( 'click', function ( e ) {
        e.preventDefault();
        $( this ).next( 'ul' ).slideToggle( 'fast' );
    });
});